<template>
  <div class="count-down">
    <div v-if="timeLeft.day >= 1" class="count-down__item">
      <span class="count-down__time">{{ timeLeft.day }}</span>
      <span class="count-down__unit">ngày</span>
      <span class="count-down__dot">:</span>
    </div>
    <div class="count-down__item">
      <span class="count-down__time">{{ timeLeft.hour }}</span>
      <span class="count-down__unit">giờ</span>
      <span class="count-down__dot">:</span>
    </div>
    <div class="count-down__item">
      <span class="count-down__time">{{ timeLeft.minute }}</span>
      <span class="count-down__unit">phút</span>
      <span class="count-down__dot">:</span>
    </div>
    <div class="count-down__item">
      <span class="count-down__time">{{ timeLeft.second }}</span>
      <span class="count-down__unit">giây</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import dayjs from 'dayjs'
import useCountDown from '~/composables/useCountDown'

interface IProps {
  endTime: any
  onFinish: () => void
}

const emit = defineEmits(['onFinish'])

const props = withDefaults(defineProps<IProps>(), {
  endTime: dayjs().add(10, 'second'),
  onFinish: () => {}
})

const handleOnFinish = () => {
  emit('onFinish', true)
  props.onFinish()
}
watch(props, () => {
  setEndTime(props.endTime)
})
const { timeLeft, setEndTime } = useCountDown({ endTime: props.endTime, onFinish: handleOnFinish })
</script>

<style lang="scss" scoped src="~/public/assets/scss/components/common/base-count-down.scss"></style>
